// react-snap zet de HTML van een publieke pagina al in #root. Bij het starten
// vervangt React die door zijn eigen weergave. Zolang de code van de pagina
// (lazy) nog laadt, stond daar ~300 ms het laadscherm: het artikel knipperde
// en de pagina sprong naar boven, zodat een link naar een kop niet werkte
// (19-10-2026). Daarom bewaren we de voorgerenderde HTML en laat de Suspense-
// terugval (VoorgerenderdeFallback) die zolang staan, alleen op de eerste pagina.
let bewaard = null;

// Deze pagina's rendert react-snap NIET voor (24-10-2026). Een voorgerenderde
// pagina werkt pas als de code er is; sinds #860 bleef die kopie staan tot ook de
// code van de pagina zelf geladen was. Op traag schoolwifi typte een leerling zijn
// toetscode in een veld dat daarna leeg opnieuw verscheen, en "Inloggen met
// e-mail" deed niets. Op /check (apparaatcontrole) stonden zolang de uitkomsten
// van de browser van react-snap: schermresolutie 800x600 en besturingssysteem
// onbekend, in het rood. Vindbaarheid telt hier niet: de inlogpagina's staan in
// robots.txt op Disallow, /check staat niet in de sitemap en nergens in een link.
// Zonder voorgerenderde HTML krijgt de browser de lege app, net als bij 200.html:
// eerst het laadscherm, dan de pagina die werkt.
// Een pad erbij? Haal het ook uit reactSnap.include in package.json.
// /en/login (27-10-2026) is dezelfde inlogpagina met een Engelse bovenbalk.
export const NIET_VOORRENDEREN = ['/login', '/en/login', '/student-login', '/check'];

const zonderSlash = (pad) => (String(pad || '/').replace(/\/+$/, '') || '/').toLowerCase();

export function magVoorrenderen(pad) {
  return !NIET_VOORRENDEREN.includes(zonderSlash(pad));
}

// react-snap rendert elke pagina in een browser met userAgent 'ReactSnap'.
export function isVoorrenderen() {
  return typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
}

// Vóór createRoot aanroepen. In de voorgerenderde HTML staat de pagina in
// <div id="root"><div class="App">…</div></div>; we bewaren de inhoud van .App.
// Op een pagina uit NIET_VOORRENDEREN nooit, ook niet als er toch nog een oude
// voorgerenderde versie binnenkomt: dan liever het laadscherm dan een dode kopie.
export function bewaarVoorgerenderd(root, pad = window.location.pathname) {
  const app = root && root.firstElementChild;
  bewaard = magVoorrenderen(pad) && app && app.classList.contains('App') && app.innerHTML.trim()
    ? { pad, html: app.innerHTML }
    : null;
}

export function voorgerenderdVoor(pad) {
  return bewaard && bewaard.pad === pad ? bewaard.html : null;
}

// Na de eerste echte weergave is de kopie niet meer nodig.
export function vergeetVoorgerenderd() {
  bewaard = null;
}
